import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dots } from "../LoadingAnimations/LoadingAnimations";
import instance from "../../Interceptor/api_instance";

const CompletedReports = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const completedDateParam = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
        const res = await instance.get(
          "safety/maintenance-report/?status=completed&status=closed&completedDate=",
          {
            params: {
              completed_at: completedDateParam,
            },
          }
        );
        setData(res.data.results);
      } catch (err) {
        console.error("Error fetching completed reports data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="graphics-card-but-small">
      <h4 className="global-h4 gray">{t("graphics-cont.completed-reports")}</h4>
      {error && <p className="error">{error}</p>}
      <div className="recent-activity">
        {loading ? (
          <Dots />
        ) : (
          <>
            {data.map((report, index) => (
              <div key={index} className="activity-item">
                <span className="global-h5 gray">
                  {report.truck
                    ? `${t("yard-tables.table-columns.truck")}: ${
                        report.truck.company
                      }-${report.truck.name}`
                    : `${t("yard-tables.table-columns.trailer")}${": "} ${
                        report.trailer.unit
                      }`}
                  {report.unit}
                </span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default CompletedReports;
